import { API, BASE_URL } from './config';

export default {
    // Get all configurations by category
    getConfigByCategory: async (category) => {
        try {
            const response = await API.get(`${BASE_URL}/webapi/config/category/${category}`);
            return response;
        } catch (error) {
            console.log('error', error);
            return error.response;
        }
    },

    // Save/Update a single configuration
    saveConfig: async (reqBody) => {
        try {
            const response = await API.post(`${BASE_URL}/webapi/config/save`, reqBody);
            return response;
        } catch (error) {
            console.log('error', error);
            return error.response;
        }
    },

    // Get all configuration categories (optional - for future use)
    getAllCategories: async () => {
        try {
            const response = await API.get(`${BASE_URL}/webapi/config/categories`);
            return response;
        } catch (error) {
            console.log('error', error);
            return error.response;
        }
    }
}
